import { render, staticRenderFns } from "./folders_list_select.vue?vue&type=template&id=60dd9a80&"
import script from "./folders_list_select.vue?vue&type=script&lang=js&"
export * from "./folders_list_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports